import React, { Component, PropTypes } from 'react';
import { Checkbox, Form } from 'semantic-ui-react';

class ComplexList extends Component {
  render() {
    const {
      label,
      title1,
      title2,
      values,
      references,
      onChangeValues,
    } = this.props;

    const isChecked = id => {
      if (values && values.find(v => v.ref === id)) {
        return true;
      } else {
        return false;
      }
    };

    const text1Value = id => {
      if (values && values.find(v => v.ref === id)) {
        return values.find(v => v.ref === id).text1;
      } else {
        return '';
      }
    };

    const text2Value = id => {
      if (values && values.find(v => v.ref === id)) {
        return values.find(v => v.ref === id).text2;
      } else {
        return '';
      }
    };

    const flushValue = (event, refId) => {
      const newValues = values.filter(v => v.ref !== refId);
      onChangeValues(event, { value: newValues });
    };

    const pushValue = (event, value) => {
      const newValues = values.filter(v => v.ref !== value.ref).concat(value);
      onChangeValues(event, { value: newValues });
    };

    const onCheck = refId => (event, data) => {
      if (data.checked) {
        pushValue(event, {
          ref: refId,
          text1: '',
          text2: '',
        });
      } else {
        flushValue(event, refId);
      }
    };

    const onText1Change = refId => (event, data) => {
      const value = values.find(v => v.ref === refId);
      if (value) {
        pushValue(event, { ...value, text1: data.value });
      } else {
        pushValue(event, { ref: refId, text1: data.value, text2: '' });
      }
    };

    const onText2Change = refId => (event, data) => {
      const value = values.find(v => v.ref === refId);
      if (value) {
        pushValue(event, { ...value, text2: data.value });
      } else {
        pushValue(event, { ref: refId, text1: '', text2: data.value });
      }
    };

    return (
      <div className="field">
        <label>{label}</label>
        <Form.Group key="headers" inline>
          <Form.Field width={5} />
          <Form.Field width={5}>{title1}</Form.Field>
          <Form.Field width={6}>{title2}</Form.Field>
        </Form.Group>
        {references &&
          references.map(ref => {
            return (
              <Form.Group key={ref.id} inline>
                <Form.Field width={5}>
                  <Checkbox
                    label={ref.label}
                    value={ref.id}
                    onChange={onCheck(ref.id)}
                    checked={isChecked(ref.id)}
                  />
                </Form.Field>
                <Form.Input
                  width={5}
                  onChange={onText1Change(ref.id)}
                  value={text1Value(ref.id)}
                  disabled={!isChecked(ref.id)}
                />
                <Form.Input
                  width={6}
                  onChange={onText2Change(ref.id)}
                  value={text2Value(ref.id)}
                  disabled={!isChecked(ref.id)}
                />
              </Form.Group>
            );
          })}
      </div>
    );
  }
}

ComplexList.PropTypes = {
  label: PropTypes.string.isRequired,
  title1: PropTypes.string.isRequired,
  title2: PropTypes.string.isRequired,
  values: PropTypes.array.isRequired,
  references: PropTypes.array.isRequired,
  onChangeValues: PropTypes.func.isRequired,
};

export default ComplexList;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/common/ComplexList.js